module.exports = __webpack_public_path__ + "static/img/mac3.145a7f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hiw/mac3.png
// module id = 217
// module chunks = 1